export enum ProgressCircleVariant {
  primarySmall = 'progressCircle-primary small',
  primaryMedium = 'progressCircle-primary medium',
  primaryLarge = 'progressCircle-primary large',
  secondarySmall = 'progressCircle-secondary small',
  secondaryMedium = 'progressCircle-secondary medium',
  secondaryLarge = 'progressCircle-secondary large',
}
